import script from "./SourcesStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SourcesStep.vue?vue&type=script&setup=true&lang=js"

import "./SourcesStep.vue?vue&type=style&index=0&id=3212619e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3212619e"]])

export default __exports__